import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import React, { type VFC, useEffect } from 'react';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { sendDwh } from 'reactApp/utils/ga';

import styles from '../../SubscriptionModal.css';

const ANALYTICS_NAME = 'mnz_auto_renewal_subscriptions_warning';

export const AutoRenewalWarning: VFC = () => {
    useEffect(() => {
        sendDwh({
            eventCategory: 'banner',
            action: 'show',
            dwh_enabled: true,
            dwhData: {
                name: ANALYTICS_NAME,
                platform: IS_PHONE_BROWSER ? 'touch' : 'web',
            },
        });
    }, []);

    return (
        <div className={styles.autoRenewalWarning}>
            <Icon20InfoCircleOutline className={styles.autoRenewalWarningIcon} />
            <span>
                Включите автоплатёж, чтобы подписка продлилась.
                <br />
                Без неё файлам может не хватить места. Если так случится, в Почте и Облаке появятся ограничения
            </span>
        </div>
    );
};
